<template>
  <div class="dsa-loading" :class="{ compact: compact }">
    <div class="dsa-spinner" aria-hidden="true"></div>
    <p v-if="text !== false">{{ displayText }}</p>
  </div>
</template>

<script>
export default {
  name: 'DsaLoading',
  props: {
    text: {
      type: [String, Boolean],
      default: 'Loading…',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayText() {
      if (this.text === false) return ''
      return this.text || 'Loading…'
    },
  },
}
</script>
